export default {
  Products: {
    Title: 'محصولات',
    Inputs: {
      Rule: 'قوانین فیلد مربوطه',
    },
    ChangeImageByCategory: {
      Btn: 'اعمال تصویر برای همه محصولات دسته بندی',
      WarningMessage: 'با تأیید این درخواست، تصویر تمامی محصولات دسته‌بندی این محصول به تصویر انتخابی شما تغییر خواهد کرد. آیا از انجام این تغییر مطمئن هستید؟',
    },
  },
}
